var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "a", d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20" }),
      React.createElement("path", { id: "c", d: "M5.4 10.8a2.487 2.487 0 0 0 2.487 2.487H14.8a5.001 5.001 0 0 1 4.953 4.313H21.6a1.6 1.6 0 0 1 1.6 1.6v5.6a1.6 1.6 0 0 1-1.6 1.6H16a1.6 1.6 0 0 1-1.6-1.6v-5.6a1.6 1.6 0 0 1 1.6-1.6h1.72a3.001 3.001 0 0 0-2.92-2.313H7.887c-.92 0-1.775-.277-2.487-.752V17.6h1.8a1.6 1.6 0 0 1 1.6 1.6v5.6a1.6 1.6 0 0 1-1.6 1.6H1.6A1.6 1.6 0 0 1 0 24.8v-5.6a1.6 1.6 0 0 1 1.6-1.6h1.8V8.8H1.6A1.6 1.6 0 0 1 0 7.2V1.6A1.6 1.6 0 0 1 1.6 0h5.6a1.6 1.6 0 0 1 1.6 1.6v5.6a1.6 1.6 0 0 1-1.6 1.6H5.4v2zm14.4 8.8h-3.4v4.8h4.8v-4.8h-1.4zM2 2v4.8h4.8V2H2zm0 17.6v4.8h4.8v-4.8H2z" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#a" })
      ),
      React.createElement("use", { fill: "#CEDBDA", xlinkHref: "#a" }),
      React.createElement(
        "g",
        { fill: "#CEDBDA", mask: "url(#b)" },
        React.createElement("path", { d: "M0 0h40v40H0z" })
      ),
      React.createElement(
        "g",
        { transform: "translate(8.4 6.8)" },
        React.createElement(
          "mask",
          { id: "d", fill: "#fff" },
          React.createElement("use", { xlinkHref: "#c" })
        ),
        React.createElement("use", { fill: "#FFF", fillRule: "nonzero", xlinkHref: "#c" }),
        React.createElement(
          "g",
          { fill: "#FFF", mask: "url(#d)" },
          React.createElement("path", { d: "M-2.4-.8h28v28h-28z" })
        )
      )
    )
  );
});